export default {
  total_orders: {
    title: 'Commandes',
    orders: 'Commandes :',
    sales_volume: 'Volume des ventes :',
    delivery_costs: 'Frais de livraison :',
  },
  cash_orders: {
    title: 'Paiement en espèces / à la porte',
    orders: 'Commandes :',
    sales_volume: 'Volume des ventes :',
    delivery_costs: 'Frais de livraison :',
  },
  online_orders: {
    title: 'Paiements en ligne',
    orders: 'Commandes :',
    sales_volume: 'Volume des ventes :',
    delivery_costs: 'Frais de livraison :',
  },
  total: 'Total',
  collected_taxes_list: {
    title: {
      online: 'Paiement en ligne',
      cash: 'Paiement en espèces',
    },
    table: {
      products_breakdown: {
        fields: {
          product: 'Produit',
          quantity: 'Quantité',
          total: 'Total',
        },
        labels: {
          total_refunded: 'Remboursé',
        },
      },
      tax_breakdown: {
        fields: {
          tax_percentage: 'TVA %',
          product_type: 'Type',
          netto: 'Net',
          tax: 'Taxe',
          brutto: 'Total',
        },
        product_types: {
          product: 'Produits {{percentage}}%',
          order_method_fee: 'Frais de livraison {{percentage}}%',
          customer_service_fee: 'Supplément en ligne',
        },
      },
    },
  },
};
